export const API_ENV = process.env.API_ENV

// 后端接口的基本路径
export const BASE_URL = {
  development: '/api',
  pre: '',
  production: '',
}[API_ENV]

// 上传地址
export const UPLOAD_URL = `${API_ENV === 'development' ? '/api' : ''}/a/file/uploadImage`
